import carousel from './carousel';

export default function initMiniCartCarousel() {
  const swiper = document.querySelector('.MiniCartCarousel.carousel');
  carousel(swiper, { loop: false });
}
